<template>
  <div class="login-page">
    <div class="main">
      <div class="title" v-if="!locked">
        <h3 class="sys-name">快手批量任务系统</h3>
      </div>

      <!-- 账号密码登录区域 -->
      <a-form-model
        v-if="!locked && !showDingtalkLogin"
        ref="form"
        :model="model"
        :rules="rules"
      >
        <a-spin :spinning="loading">
          <template v-if="locked">
            <a-alert
                message="登录限制"
                description="由于您登录失败次数过多，已被系统暂时限制登录，请稍后重试！"
                type="warning"
                show-icon
            />
          </template>
          <template v-else>
            <a-form-model-item prop="username">
              <a-input placeholder="账号" size="large" v-model="model.username">
                <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
              </a-input>
            </a-form-model-item>
            <a-form-model-item prop="password">
              <a-input-password placeholder="密码" size="large" v-model="model.password">
                <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
              </a-input-password>
            </a-form-model-item>
            <a-form-item class="login-item">
              <a-button
                title="登陆"
                size="large"
                type="primary"
                htmlType="submit"
                block
                @click="login"
              >
                登录
              </a-button>
            </a-form-item>
          </template>
        </a-spin>
      </a-form-model>

      <!-- 【已停用】钉钉登录入口：状态展示与登录按钮暂不展示 -->
      <template v-if="false">
      <!-- 钉钉登录状态显示（不再需要二维码组件） -->
      <div v-if="showDingtalkLogin" class="dingtalk-login-status">
        <!-- 显示钉钉登录状态 -->
        <div v-if="dingtalkLoginStatus === 'loading'" class="dingtalk-loading">
          <a-spin tip="正在处理登录..." size="large" />
        </div>
        
        <div v-else-if="dingtalkLoginStatus === 'processing'" class="dingtalk-processing">
          <a-spin tip="正在登录..." size="large" />
        </div>
        
        <div v-else-if="dingtalkLoginStatus === 'error'" class="dingtalk-error">
          <a-alert 
            :message="dingtalkLoginError" 
            type="error" 
            show-icon
          />
          <div class="dingtalk-error-actions">
            <a-button @click="backToPasswordLogin" type="primary">
              返回重新登录
            </a-button>
            <a-button @click="retryDingtalkLogin">
              <a-icon type="reload" /> 重试
            </a-button>
          </div>
        </div>
      </div>
      </template>

      <!-- 【已停用】钉钉登录入口 -->
      <!-- 钉钉登录入口（直接显示在登录表单下方） -->
      <div class="dingtalk-entry" v-if="false">
        <a-divider>或</a-divider>
        <!-- 改为直接跳转到钉钉授权页面的按钮 -->
        <a-button
          type="default"
          size="large"
          block
          @click="handleDingtalkLoginClick('zhumengren')"
          :loading="dingtalkLoginLoading"
          class="dingtalk-direct-login-btn"
        >
          <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMUMxMS44NjYgMSAxNSA0LjEzNCAxNSA4QzE1IDExLjg2NiAxMS44NjYgMTUgOCAxNUM0LjEzNCAxNSAxIDExLjg2NiAxIDhDMSA0LjEzNCA0LjEzNCAxIDggMVoiIGZpbGw9IiMwMDdBRkYiLz4KPHBhdGggZD0iTTguNjM0OCA2LjEwNzIxQzkuNTc3MzUgNS44MzUxMSA5Ljg5MjcxIDUuODcxNjMgMTAuMjk2NiA2LjEyMzUzQzEwLjU5MTIgNi4zMDAyNCAxMC44NDk5IDYuNjA1MzYgMTAuODY3NSA2Ljk4MDg5QzEwLjg3NjYgNy4xNjU5NiAxMC44NDk5IDcuMzQ5NTQgMTAuNzg5MyA3LjUyNTIxQzEwLjI0MjEgOS4zNjU3MSA4LjU0NzgxIDEzLjA5MTQgOC41NDc4MSAxMy4wOTE0QzguNTQ3ODEgMTMuMDkxNCA4LjM2NzQ2IDExLjUyODQgOS4wMjI4OCA5LjUwMjU5QzkuNTI5MSA4LjA2MjMxIDkuOTg2OTQgNy42Mjk4MyAxMC4wMjI0IDcuMDQyNzFDOS45NDE1MiA2LjY5MzIyIDkuNzMyMTQgNi4zOTM4IDkuNDM3OTQgNi4yMjAwOUM5LjA5NzU3IDYuMDI1MjIgOC42MjQ2NiA2LjAyMDY4IDguMjUwNjQgNi4yMDUyMkM3LjYwMjIxIDYuNTM2NzQgNi45NzU4NyA3LjEwMDY1IDYuNzE1MjQgNy40ODA0NkM1LjU5MTQxIDguOTkwNzMgNC4wNjExOSAxMS42ODkzIDQuMDYxMTkgMTEuNjg5M0MzLjg1ODIgMTEuMzA2IDMuNzUwOTkgMTAuODg5IDMuNzUwOTkgMTAuNDY2QzMuNzUwOTkgOC45NDkyNiA0LjEwNTc5IDYuOTk0MTcgNS4wNzg1MiA1LjkwNzMxQzYuMDUxMjUgNC44MjA0NSA3LjY5MjI1IDYuMzkwMzIgOC42MzQ4IDYuMTA3MjFaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K" 
            style="width: 16px; height: 16px; margin-right: 8px; vertical-align: -3px;"
          />
          逐梦人钉钉账号登录
        </a-button>
        <!-- <p class="dingtalk-tip">
          <a-icon type="info-circle" /> 首次使用需管理员在后台绑定账号
        </p> -->
      </div>

      <div class="dingtalk-entry" v-if="false">
        <a-divider>或</a-divider>
        <!-- 改为直接跳转到钉钉授权页面的按钮 -->
        <a-button
          type="default"
          size="large"
          block
          @click="handleDingtalkLoginClick('chusai')"
          :loading="dingtalkLoginLoading"
          class="dingtalk-direct-login-btn"
        >
          <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMUMxMS44NjYgMSAxNSA0LjEzNCAxNSA4QzE1IDExLjg2NiAxMS44NjYgMTUgOCAxNUM0LjEzNCAxNSAxIDExLjg2NiAxIDhDMSA0LjEzNCA0LjEzNCAxIDggMVoiIGZpbGw9IiMwMDdBRkYiLz4KPHBhdGggZD0iTTguNjM0OCA2LjEwNzIxQzkuNTc3MzUgNS44MzUxMSA5Ljg5MjcxIDUuODcxNjMgMTAuMjk2NiA2LjEyMzUzQzEwLjU5MTIgNi4zMDAyNCAxMC44NDk5IDYuNjA1MzYgMTAuODY3NSA2Ljk4MDg5QzEwLjg3NjYgNy4xNjU5NiAxMC44NDk5IDcuMzQ5NTQgMTAuNzg5MyA3LjUyNTIxQzEwLjI0MjEgOS4zNjU3MSA4LjU0NzgxIDEzLjA5MTQgOC41NDc4MSAxMy4wOTE0QzguNTQ3ODEgMTMuMDkxNCA4LjM2NzQ2IDExLjUyODQgOS4wMjI4OCA5LjUwMjU5QzkuNTI5MSA4LjA2MjMxIDkuOTg2OTQgNy42Mjk4MyAxMC4wMjI0IDcuMDQyNzFDOS45NDE1MiA2LjY5MzIyIDkuNzMyMTQgNi4zOTM4IDkuNDM3OTQgNi4yMjAwOUM5LjA5NzU3IDYuMDI1MjIgOC42MjQ2NiA2LjAyMDY4IDguMjUwNjQgNi4yMDUyMkM3LjYwMjIxIDYuNTM2NzQgNi45NzU4NyA3LjEwMDY1IDYuNzE1MjQgNy40ODA0NkM1LjU5MTQxIDguOTkwNzMgNC4wNjExOSAxMS42ODkzIDQuMDYxMTkgMTEuNjg5M0MzLjg1ODIgMTEuMzA2IDMuNzUwOTkgMTAuODg5IDMuNzUwOTkgMTAuNDY2QzMuNzUwOTkgOC45NDkyNiA0LjEwNTc5IDYuOTk0MTcgNS4wNzg1MiA1LjkwNzMxQzYuMDUxMjUgNC44MjA0NSA3LjY5MjI1IDYuMzkwMzIgOC42MzQ4IDYuMTA3MjFaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K" 
            style="width: 16px; height: 16px; margin-right: 8px; vertical-align: -3px;"
          />
          新出赛钉钉账号登录
        </a-button>
      </div>

      <div class="copyright" v-if="!locked">Copyright © {{ (new Date()).getFullYear() }} 快手批量任务系统</div>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import 'Login';
</style>

<script>
import Login from './Login'
export default Login
</script>
